import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import '../Style/App.css';
import { API_URL } from '../config/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  axios.defaults.withCredentials = true;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      const res = await axios.post(
        `${API_URL}/auth/forgot-password`,
        { email },
        { withCredentials: true }
      );
      
      if (res.data.ok) {
        setSuccess(true);
        // Redirect to reset password page after 2 seconds
        setTimeout(() => {
          navigate(`/reset-password?email=${encodeURIComponent(email)}`);
        }, 2000);
      }
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="loginPage">
        <img
          src="/GradyStar.png"
          alt="Logo"
          className="logo"
        />
        <div className="loginForm">
          <h2 className="text-center"><strong>Check Your Email</strong></h2>
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <p style={{ color: '#28a745', marginBottom: '10px' }}>
               Password reset code sent successfully!
            </p>
            <p style={{ fontSize: '14px', color: '#666' }}>
              We've sent a password reset code to <strong>{email}</strong>
            </p>
            <p style={{ fontSize: '14px', color: '#666' }}>
              Redirecting to password reset page...
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <Link 
              to={`/reset-password?email=${encodeURIComponent(email)}`}
              style={{ color: '#0b3f1f', textDecoration: 'none' }}
            >
              Continue to Reset Password →
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="loginPage">
      <img
        src="/trans_logo.png"
        alt="Logo"
        className="logo"
      />
      <div className="loginForm">
        {error && <div className="text-danger mb-2">{error}</div>}
        <h2 className="text-center"><strong>Forgot Password</strong></h2>
        <p style={{ textAlign: 'center', marginBottom: '20px', fontSize: '14px', color: '#666' }}>
          Enter your email address and we'll send you a code to reset your password.
        </p>
        
        <form onSubmit={handleSubmit}>
          <div style={{textAlign: "left", marginBottom: "15px"}}>
            <label style={{display: "block", marginBottom: "5px"}}><strong>Email:</strong></label>
            <input
              type="email"
              name="email"
              className="modern-input"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Enter your email address"
              required
              disabled={loading}
            />
          </div>
          
          <button 
            className="modern-btn" 
            type="submit"
            disabled={loading}
            style={{ opacity: loading ? 0.7 : 1 }}
          >
            {loading ? 'Sending...' : 'Send Reset Code'}
          </button>
          
          <div style={{marginTop: "15px", textAlign: "center"}}>
            <p style={{fontSize: "14px", margin: "0"}}>
              Remember your password? <Link to="/login" style={{color: "#0b3f1f"}}>Sign In</Link>
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
